export const FIELDS_TABLE_CLIENT = [
    {
      title: "Nombre",
      field: "name",
      type: "text"
    },
    
    {
      title: "Acciones",
      field: "actions",
      type: "text"
    }
  ]
